import Image from "next/image";
import Link from "next/link";

export default function IosAndAndroid() {
  const dmAppUrl = !(typeof window === "undefined")
    ? /(localhost)|(staging)/.test(window.location.hostname)
      ? "https://staging.datamynt.com"
      : "https://datamynt.com"
    : "#";

  return (
    <div>
      Our iOS and Android apps are currently in development and we’re planning
      to have them available before the end of 2022.
      <br />
      <br />
      Nevertheless, until our mobile apps are ready, you can add the Data Mynt
      app shortcut to your mobile device home screen directly from your phone
      browser. Here’s the step-by-step guide:
      <br />
      <br />
      <b>Safari Browser (iOS)</b>
      <ul>
        <li>
          Navigate to the{" "}
          <Link href={dmAppUrl}>
            <a target="_blank" rel="noreferrer">
              Data Mynt app
            </a>
          </Link>{" "}
          from your browser.
        </li>
        <li>
          Tap the square icon with an arrow pointing out of it at the bottom of
          your screen.
        </li>
        <div className="flex items-center justify-center my-4">
          <Image
            alt="How to add an ios shortcut to your phone"
            width={300}
            height={110}
            src="/appIconFirstStep.png"
          />
        </div>
        <li>Scroll down and tap “Add to Home Screen”.</li>
        <li>Accept the suggested name or enter a custom one.</li>
        <li>Tap “Add” &amp; save the shortcut to the home screen.</li>
      </ul>
      <b>Chrome Browser (Android)</b>
      <ul>
        <li>
          Navigate to the{" "}
          <Link href={dmAppUrl}>
            <a target="_blank" rel="noreferrer">
              Data Mynt app
            </a>
          </Link>{" "}
          from your Chrome browser.
        </li>
        <li>
          Tap the menu icon represented by 3 dots in the upper right corner of
          the browser app.
        </li>
        <li>Tap “Add to Home Screen”.</li>
        <li>
          Enter a name for the shortcut or use the default one provided by
          Chrome.
        </li>
        <li>Tap “Add” &amp; save the shortcut to the home screen.</li>
      </ul>
    </div>
  );
}
